<template>
  <article class="pennants-layout">
    <div class="pennants" v-if="isAdd">
      <h3>送锦旗<span>(可多选)</span></h3>
      <p>{{ tip }}</p>
      <section>
        <div class="swiper-container" ref="mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in pennantsList"
              :key="index"
            >
              <div
                class="item"
                @click="selectCurrent(item, $event)"
                :class="{ selected: item.selected }"
              >
                <h3>{{ item.silkBannerName }}</h3>
                <Pnt :item="item" :timeCn="YCn" :workerName="workerName" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div v-if="selectedPennants.length > 0">
        您已选择<span v-for="item in selectedPennants"
          >&nbsp;“{{ item.silkBannerName }}”</span
        ><span>锦旗</span>&nbsp;赠送月嫂
      </div>
    </div>
    <div class="pennants-look" v-else>
      <section>
        <i></i>
        <div class="swiper-container" ref="mySwiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              :class="{ isOne: pennantsList.length == 1 }"
              v-for="(item, index) in pennantsList"
              :key="index"
            >
              <div class="item">
                <Pnt
                  :item="item"
                  :timeCn="item.createTime | stampToCn"
                  :workerName="workerName"
                />
                <h3>{{ item.silkBannerName }}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div v-if="pennantsList.length > 0">
        已赠送<span>&nbsp;“{{ pennantsList.length }}面锦旗”</span>&nbsp;给月嫂
      </div>
    </div>
  </article>
</template>
<script>
import Swiper from 'swiper/js/swiper.min.js' //防止dom7问题
import 'swiper/css/swiper.css'

import mixins from './mixins'
import Pnt from './pnt'

const arrDateZH = [
  '零',
  '一',
  '二',
  '三',
  '四',
  '五',
  '六',
  '七',
  '八',
  '九',
  '十'
]
function getNumberCN(num) {
  const numStr = `${num}`
  let numList = numStr.split('')

  let arr2 = numList.map(o => arrDateZH[+o])
  if ([10, 11, 12].indexOf(num) !== -1) {
    arr2[0] = arrDateZH[arrDateZH.length - 1]
  }
  return arr2.join('')
}

function getYcn(timestamp) {
  const currentDate = timestamp ? new Date(timestamp) : new Date()
  const Y = currentDate.getFullYear()
  const M = currentDate.getMonth() + 1
  return `${getNumberCN(Y)}年${getNumberCN(M)}月`
}

const swiperOption = {
  effect: 'coverflow',
  slidesPerView: 2,
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 100,
    modifier: 2,
    slideShadows: false
  }
}

export default {
  mixins: [mixins],
  components: { Pnt },
  props: {
    pennantsList: {
      type: Array,
      default() {
        return []
      }
    },
    workerName: {
      type: String,
      default: ''
    }
  },
  // watch: {
  //     pennantsList:{
  //         handler(value){
  //             if(value.length > 0) this.initSwiper();
  //         },
  //         deep: true
  //     }
  // },
  data() {
    return {
      YCn: '',
      selectedPennants: []
    }
  },
  filters: {
    stampToCn(timestamp) {
      return getYcn(timestamp * 1000)
    }
  },
  computed: {
    tip() {
      return (
        this.jqTip ||
        '小小锦旗代表着月嫂至高无上的荣誉，如果您对月嫂的服务满意，快来免费赠送吧！'
      )
    }
    // selectedPennants(){
    //    return this.pennantsList.filter(item => item.selected)
    // }
  },

  created() {
    if (this.isAdd) {
      this.YCn = getYcn()
    }
  },
  mounted() {
    this.initSwiper()
  },
  beforeDestroy() {
    if (this.mySwiper) this.mySwiper.destroy()
  },
  methods: {
    selectCurrent(item, event) {
      const parentClassNames = event.currentTarget.parentElement.className
      if (parentClassNames.indexOf('swiper-slide-active') > -1) {
        item.selected = !item.selected
        this.$forceUpdate()
        this.selectedPennants = this.pennantsList.filter(item => item.selected)
        this.$emit('onChangePennants', this.selectedPennants)
      }
    },
    initSwiper() {
      const el = this.$refs.mySwiper
      let config = {}
      if (this.isAdd) {
        config = swiperOption
      } else {
        config.slidesPerView = this.pennantsList.length > 1 ? 2 : 'auto'
      }
      if (el) {
        this.$nextTick(() => {
          try {
            this.mySwiper = new Swiper(el, config)
          } catch (e) {}
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.pennants-layout {
  > div {
    background-color: #fff;
    overflow: hidden;
    border-radius: rem(16px);
    padding: rem(36px) rem(24px);
  }
}
.pennants {
  margin-top: rem(24px);
  padding: rem(24px);
  padding-bottom: rem(36px);

  > h3 {
    line-height: rem(40px);
    font-size: rem(32px);
    color: #121212;
    padding: rem(12px) 0;
    padding-top: 0;
    font-weight: bold;
    span {
      padding-left: rem(8px);
      font-size: rem(22px);
      color: #999999;
    }
  }
  > p {
    font-size: rem(26px);
    color: #808080;
    padding: rem(8px) rem(34px);
    line-height: rem(37px);
    background: url('~@/assets/images/evaluate/icon-jq_tip@3x.png') no-repeat
      left rem(15px);
    background-size: rem(22px) auto;
  }
  > section {
    overflow: hidden;
  }
  > div {
    font-size: rem(26px);
    color: #000000;
    line-height: rem(32px);
    padding-top: rem(24px);
    span {
      color: #ff397e;
    }
  }
  .swiper-container {
    margin: 0 rem(-80px);
    margin-top: rem(24px);
    .swiper-wrapper {
      .swiper-slide {
        .item {
          background-image: url('~@/assets/images/evaluate/jingqi_selected_n@3x.png');
          h3 {
            background-image: url('~@/assets/images/evaluate/tittle-edit@3x.png');
            background-size: rem(280px) auto;
            background-position: top center;
            background-repeat: no-repeat;
          }
          &.selected {
            background-image: url('~@/assets/images/evaluate/jingqi_selected@3x.png');
          }
        }
      }
    }
  }
}
.pennants-look {
  margin-top: rem(24px);

  > section {
    overflow: hidden;
    i {
      display: block;
      width: 100%;
      background: url('~@/assets/images/evaluate/tittle-jq@3x.png') no-repeat
        center;
      background-size: rem(314px) auto;
      height: rem(49px);
      margin-bottom: rem(30px);
      margin-top: rem(6px);
    }
  }
  > div {
    font-size: rem(26px);
    color: #000000;
    line-height: rem(32px);
    padding-top: rem(24px);

    span {
      font-weight: bold;
      color: #ff397e;
    }
  }
  .swiper-container {
    margin: 0 rem(-20px);
    .swiper-wrapper {
      .swiper-slide {
        height: auto;
        width: rem(340px);
        &.isOne {
          width: 100%;
        }
        .item {
          margin-top: rem(-24px);

          width: rem(340px);
          text-align: center;
          > div {
            width: 100%;
            transform: scale(0.9);
            margin-bottom: rem(-24px);
            height: rem(400px);
            padding: rem(46px) rem(60px);
            padding-bottom: rem(70px);
          }
          h3 {
            width: auto;
            height: rem(40px);
            line-height: rem(42px);
            padding: 0 rem(18px);
            font-size: rem(26px);
            color: #000000;
            background: #f7f7f7;
            display: inline-block;
            border-radius: rem(36px);
            margin-top: rem(16px);
            font-weight: normal;
            letter-spacing: rem(2px);
          }
        }
      }
    }
  }
}
.swiper-container {
  margin-top: rem(22px);
  .swiper-wrapper {
    .swiper-slide {
      height: auto;
      .item {
        width: rem(357px);
        margin: 0 auto;
        background-size: rem(44px) auto;
        background-position: right bottom;
        background-repeat: no-repeat;
      }

      h3 {
        font-size: rem(30px);
        font-weight: bold;
        color: #000000;
        letter-spacing: rem(4px);
        line-height: rem(42px);
        text-align: center;
        width: 100%;
        padding-bottom: rem(30px);
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.pennants {
  .swiper-slide {
    &.swiper-slide-prev,
    &.swiper-slide-next {
      .item {
        opacity: 0.5;
        h3 {
          opacity: 0.2;
        }
      }
    }
  }
}
</style>
